import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-financial-tool',
  templateUrl: './financial-tool.component.html',
})
export class FinancialToolComponent {
  type: 'agency' | 'school' = 'agency';
  tab!: string;
  showTab: boolean = false;
  isTabTransitioning: boolean = false;

  constructor(private AR: ActivatedRoute) {
    this.AR.params.subscribe((params: any) => {
      this.type = params.type;
      this.tab = params.tab;

      if (!params.tab) {
        this.showTab = true;
        this.tab = 'collect';
      }
    });
  }

  private readonly TAB_TRANSITION_DELAY = 200;

  /**
   * Triggers a view refresh when switching tabs to ensure proper component state updates.
   * This is a temporary solution until a proper state management system is implemented.
   *
   * @returns void
   * @todo Replace with proper state management or change detection strategy
   * @author Martin Batun Tec.
   */
  handleTabTransition(): void {
    this.isTabTransitioning = true;
    setTimeout(() => {
      this.isTabTransitioning = false;
    }, this.TAB_TRANSITION_DELAY);
  }
}
